module.exports = __webpack_public_path__ + "img/avatar3.e93db838.jpg";